import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../core/http/api.service';
import {UtilsService} from '../../core/services/utils/utils.service';

@Component({
  selector: 'app-ecommerce-orders',
  templateUrl: './ecommerce-orders.component.html',
  styleUrls: ['../ecommerce-shared.css'],
  standalone: false
})
export class EcommerceOrdersComponent implements OnInit {
  orders: any[] = [];
  loading = false;
  deletingId = '';
  detail: any = null;
  filters = {keyword: '', status: '', type: ''};
  nextStatus = '';
  note = '';
  transitions: any = {
    order_placed: ['processing', 'cancelled', 'refunded'],
    processing: ['shipped', 'cancelled', 'refunded'],
    shipped: ['out_for_delivery', 'delivered', 'refunded'],
    out_for_delivery: ['delivered', 'refunded'],
    delivered: ['refunded']
  };

  constructor(private api: ApiService, private utils: UtilsService) {}
  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading = true;
    this.api.getEcommerceOrders().subscribe({
      next: (res) => { this.orders = res.data || []; this.loading = false; },
      error: (err) => { this.loading = false; this.utils.resErr(err); }
    });
  }

  get filtered(): any[] {
    const keyword = this.filters.keyword.toLowerCase().trim();
    return this.orders.filter((order) => {
      const user = order.user || {};
      return (!keyword || `${order.orderId} ${order.transactionId} ${order.productSnapshot?.title} ${user.firstName} ${user.lastName} ${user.email}`.toLowerCase().includes(keyword)) &&
        (!this.filters.status || order.orderStatus === this.filters.status) &&
        (!this.filters.type || order.productSnapshot?.productType === this.filters.type);
    });
  }

  open(order: any): void {
    this.api.getEcommerceOrder(order._id || order.id).subscribe({
      next: (res) => { this.detail = res.data; this.nextStatus = ''; this.note = ''; },
      error: (err) => this.utils.resErr(err)
    });
  }

  close(): void { this.detail = null; }

  deleteOrder(order: any): void {
    const id = String(order?._id || order?.id || '');
    if (!id || !window.confirm(
      `Permanently delete order ${order.orderId}? This cannot be undone. The customer will lose this order and any download access. Payment is not refunded.`
    )) return;
    this.deletingId = id;
    this.api.deleteEcommerceOrder(id).subscribe({
      next: (res) => {
        this.orders = this.orders.filter((item) => String(item._id || item.id) !== id);
        if (String(this.detail?._id || this.detail?.id) === id) this.close();
        this.deletingId = '';
        this.utils.toastSuccess(res.message);
      },
      error: (err) => { this.deletingId = ''; this.utils.resErr(err); }
    });
  }

  updateStatus(): void {
    if (!this.nextStatus) return;
    this.api.updateEcommerceOrderStatus(this.detail._id || this.detail.id, {status: this.nextStatus, note: this.note}).subscribe({
      next: (res) => { this.utils.toastSuccess(res.message); this.detail = res.data; this.nextStatus = ''; this.load(); },
      error: (err) => this.utils.resErr(err)
    });
  }

  retry(): void {
    this.api.retryEcommerceOrderDelivery(this.detail._id || this.detail.id).subscribe({
      next: (res) => { this.utils.toastSuccess(res.message); this.detail = res.data; this.load(); },
      error: (err) => this.utils.resErr(err)
    });
  }

  money(minor: number, currency: string): string {
    return new Intl.NumberFormat('en-IN', {style: 'currency', currency}).format(Number(minor || 0) / 100);
  }
}
